import {useEffect} from "react";
import {Top, Bottom, LinkButton} from "parts";
import {getItem, setStep, setTrack, useSurvey} from "utils";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {GoalTop} from "../parts";

export const colors = ['#87D225', '#B172E8', '#579DEF']

export function Summarize({step, toAdd, nextUrl, preload}) {

  const
    {uid} = useParams(),
    navigate = useNavigate(),
    {t} = useTranslation('common', {keyPrefix: 'summarize'})

  const
    {
      surveyList,
      state: {resultList}
    } = useSurvey(),

    keys = ['confidence', 'charisma', 'emotional_intelligence'],
    data = getItem('summarize', {}, window.sessionStorage),

    levels = Object.entries(data.levels || {})

    // {
    //   "levels": {
    //     "confidence": 85,
    //     "charisma": 70,
    //     "eq": 60
    //   },
    //   "style": "Expressive, Melodic, Direct, Focused",
    //   "confidence": "You possess strong confidence, readily expressing yourself and unafraid of public speaking.",
    //   "charisma": "Your melodic voice and extroverted nature contribute to your charisma, though adapting to different audiences could enhance your connection.",
    //   "emotional_intelligence": "While you're a talker, focusing on adapting your style and understanding others' feelings will boost your EQ.",
    //   "tips": [
    //     "Practice active listening by summarizing what others say to ensure understanding.",
    //     "Observe and mirror the communication style of those you interact with to build rapport.",
    //     "Even with limited time, dedicate a few minutes daily to reflect on your interactions and identify areas for improvement."
    //   ]
    // }

  useEffect(() => {
    if (
      !uid && (
        !data.levels ||
        resultList.length < surveyList.length
      )
    ) {
      navigate(nextUrl, {replace: true})
      return
    }

    fetch(
      process.env.REACT_APP_API_URI + 'web-sessions/coach',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid: (window.session_uid || window.sessionStorage.getItem('session_uid')),
        })
      }
    )
      .then(() => {})

    setStep({...step, uid}, toAdd, true)
    setTrack('coach')
  }, [])

  return (
    <div className={'wrap fixed'}>
      <Top>
        <GoalTop/>

        <div className={'block secondary'}>
          <div className={'row gap-2 mb-4'}>
            <img width={40} height={40} alt={''} src={'/charisma/static/img/survey/avatar.png'}/>
            <div className={'surface text-start small w-100 px-2 py-1'} style={{lineHeight: '21px'}}>
              {t('wisdom')}
            </div>
          </div>
          <div className={'gap-3'} style={{display: 'flex', flexWrap: 'wrap', textTransform: 'capitalize'}}>
            {data.style?.split(', ').map(item =>
              <div key={item} className={'surface px-2 py-1 small tg'}>{item}</div>
            )}
          </div>
        </div>

        {
          keys.map((name, i) =>
            <div key={i} className={'row gap-0'}>
              <div className={'block h-100'}
                   style={{
                     backgroundColor: colors[i], width: 8, padding: 0,
                     borderTopRightRadius: 0, borderBottomRightRadius: 0
                   }}
              />
              <div className={'block secondary items gap-3 text-start'}
                   style={{padding: '16px 20px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
              >
                <div className={'row wide'}>
                  <strong>{t(`level.${name}`)} {levels[i]?.[0] && name !== levels[i][0] ? `(${t(`level.${levels[i][0]}`)})` : ''}</strong>
                  <strong>{levels[i]?.[1]}%</strong>
                </div>
                <hr/>
                <small className={'notice-2'} style={{lineHeight: '21px'}}>{data[name]}</small>
              </div>
            </div>
          )
        }

        <h2 className={'h1 pre-line'}>{t('h2')}</h2>
        {
          data.tips?.map((txt, ind) =>
          <div key={ind} className={'row gap-2'}>
            <img width={40} height={40} alt={''} style={{alignSelf: 'start'}}
                 src={'/charisma/static/img/survey/avatar.png'}/>
            <div className={'surface text-start violet px-2 py-1'}>
              <h4>Tip #{ind + 1}</h4>
              <small>{txt}</small>
            </div>
          </div>
          )
        }

        <LinkButton className={'fade-in'} to={nextUrl}>{t('btn')}</LinkButton>
      </Top>

      <Bottom footer={false} preload={preload}/>
    </div>
  )
}